import { gql } from "@apollo/client";

export const SUGGEST_TAGS = gql`
  query suggestTags($projectId: ID!, $type: TagType!) {
    suggestTags(projectId: $projectId, type: $type)
  }
`;
